import React from "react";
import AboutLocalityProperty from "../../components/public/userExploreLocality/AboutLocalityProperty";
// import HomeTestimonials from "../../components/public/UserHome/HomeTestimonials";
import NewProjects from "../../components/public/userResidentialPropertiesDetails/NewProjects";
import TopDevelopers from "../../components/public/userCommon/TopDevelopers";
import FAQSection from "../../components/public/userLogin/FAQSection";
import RatingsReview from "../../components/public/userExploreLocality/RatingsReview";
import PropertyListing from "../../components/public/userExploreLocality/PropertyListing";
import ExploreTestimonials from "../../components/public/userExploreLocality/ExploreTestimonials";
import PropertyForSell from "../../components/public/userExploreLocality/PropertyForSell";

const ExploreLocality = () => {
  return (
    <div className="overflow-hidden">
      <AboutLocalityProperty />

      <div className="px-4 sm:px-6 md:px-8 lg:px-10 grid grid-cols-1 xl:grid-cols-4 xl:gap-10">
        {/* left side */}
        <div className="col-span-1 lg:col-span-3">
          <div className="pt-6 md:pt-8 lg:pt-10">
            <RatingsReview />
          </div>

          <div className="pt-6 md:pt-8 lg:pt-10">
            <ExploreTestimonials />
          </div>
          <PropertyForSell />
          <NewProjects />
        </div>

        {/* right side */}
        <div className="col-span-1 xl:py-10">
          <PropertyListing />
        </div>
      </div>

      <div className="px-4 sm:px-6 md:px-8 lg:px-10 pt-6 md:pt-8 lg:pt-0">
        <TopDevelopers title="Builders in Kalinganagar" />
      </div>

      <div className="px-4 sm:px-6 md:px-8 lg:px-10">
        <FAQSection />
      </div>
    </div>
  );
};

export default ExploreLocality;
